import { useEffect, useState } from 'react';
import CommonService from '../services/common.service';

/**
 * Fetches `/master/operational-status` → `operational_status`
 * (operational_status_id, operational_status).
 * @param {boolean} enabled
 */
export function useMasterOperationalStatus(enabled = true) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(!!enabled);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setList([]);
      setLoading(false);
      setError(null);
      return undefined;
    }
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const response = await CommonService.get('/master/operational-status');
        if (cancelled) return;
        const raw = response?.data;
        const rows = Array.isArray(raw) ? raw : [];
        setList(rows);
      } catch (e) {
        if (!cancelled) {
          setError(e);
          setList([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { list, loading, error };
}
